import React from "react";

const ZippingStatusBar = (isZippingStatusBarVisible) => {
  return <div>Zipping...</div>;
};

export default ZippingStatusBar;
